import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { setLocale } from "../store/features/globalSlice";

import { toast } from "react-toastify";

import { useLocale } from "../hooks/useLocale";

export const LOCALES = [
  {
    locale: "en",
    countryISO2: "US",
    name: "English",
  },
  {
    locale: "ae",
    countryISO2: "AE",
    name: "Arabic",
  },
];

const LocaleSwitch = () => {
  const dispatch = useDispatch();
  const locale = useSelector((s) => s.global.locale);

  const { i18n } = useTranslation();

  const handleLangSelect = (locale) => {
    const lang = LOCALES.find((item) => item.locale === locale);
    if (!lang) return;

    // update locale on store
    dispatch(setLocale(lang));

    // change the locale on the UI
    i18n.changeLanguage(lang.locale);

    toast(`Switched To ${lang.name} Language`, {
      type: "success",
    });
  };

  return (
    <div
      className="input-group ms-3 d-none d-sm-none d-md-flex d-lg-flex"
      style={{ width: "180px" }}
    >
      <label className="input-group-text" htmlFor="localeSwitcher">
        <img src={getFlag(locale?.countryISO2)} />
      </label>
      <select
        className="form-select text-capitalize"
        id="localeSwitcher"
        onChange={(e) => handleLangSelect(e.target.value)}
        value={locale.locale}
      >
        {LOCALES.map((item) => {
          return <Option key={item.locale} item={item} />;
        })}
      </select>
    </div>
  );
};

const Option = ({ item }) => {
  const { localize } = useLocale();
  return (
    <option value={item.locale}>
      {localize(`common.lang.${item.locale}`, { returnObjects: true })}
    </option>
  );
};

const getFlag = (iso2 = "US", size = 16) =>
  `https://flagsapi.com/${iso2}/flat/${size}.png`;

export default LocaleSwitch;
